import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import BusinessSizeService from './service'

export const getBusinessSizeTable = createAsyncThunk(
  'companyAnalysis/industryOverview/businessSize/getBusinessSizeTable',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BusinessSizeService.getBusinessSizeTable(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const exportBusinessSize = createAsyncThunk(
  'companyAnalysis/industryOverview/businessSize/exportBusinessSize',
  async (params) => {
    try {
      const res = await BusinessSizeService.exportBusinessSize(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
